import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import $ from "jquery";

function retina() {
	if ("devicePixelRatio" in window && window.devicePixelRatio === 2) {
		var imgToReplace = $("img.replace-2x").get();
		for (var i = 0, l = imgToReplace.length; i < l; i++) {
			var src = imgToReplace[i].src;
			src = src.replace(/\.(png|jpg|gif)+$/i, "@2x.$1");
			imgToReplace[i].src = src;
			$(imgToReplace[i]).load(function () {
				$(this).addClass("loaded");
			});
		}
	}
}
retina();

// $(window).load(function () {
// 	$("body").addClass("loader");
// });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);
